import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { motion } from 'framer-motion';
import { fadeIn } from '../utils/motion';

// An empty screen is an invitation to act, not just a "nothing here" notice --
// each page passes a message specific to what's missing.
const EmptyState = ({ icon, title, subtitle }) => (
  <Box
    component={motion.div}
    variants={fadeIn}
    initial="hidden"
    animate="show"
    sx={{
      textAlign: 'center',
      py: 7,
      px: 3,
      borderRadius: '18px',
      border: '1px dashed',
      borderColor: (t) => alpha(t.palette.text.primary, 0.15),
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        mx: 'auto',
        mb: 2,
        borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary.main',
        backgroundColor: (t) => alpha(t.palette.primary.main, 0.12),
      }}
    >
      {icon}
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>{title}</Typography>
    {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
  </Box>
);

export default EmptyState;
